import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import { IconButton, Stack } from "@mui/material";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';

const CustomTooltip = ({ continuous, index, step, backProps, closeProps, primaryProps, size, tooltipProps, }) => {

    const { title, content } = step;

    return (
        <div { ...tooltipProps }>
            <Paper elevation={ 8 } sx={{ padding: 2, maxWidth: '300px' }}>
                <Typography variant="overline">{ title }</Typography>
                <Typography><span dangerouslySetInnerHTML={{ __html: content }} /></Typography>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <IconButton disabled={ ( index === 0 ) } aria-label="Back" { ...backProps }>
                        <NavigateBeforeIcon />
                    </IconButton>
                    <Typography variant="caption">
                        { index + 1 }/{ size }
                    </Typography>
                    <IconButton disabled={ !continuous } aria-label="Next" { ...primaryProps }>
                        <NavigateNextIcon />
                    </IconButton>
                </Stack>
            </Paper>
        </div>
    )

}

export default CustomTooltip